<div class="audio-player-container" [class.loading]="isLoading()" [class.full-width]="fullWidth()">
  <audio #audioElement hidden preload="auto" (play)="played.emit()" (pause)="paused.emit()" (ended)="ended.emit()"></audio>

  <button mat-icon-button (click)="togglePlayPause()" class="play-button" [matTooltip]="isPlaying() ? 'Pause' : 'Play'" [disabled]="isLoading()" aria-label="Play/Pause button">
    <mat-icon>{{ isPlaying() ? 'pause' : 'play_arrow' }}</mat-icon>
  </button>

  <div #waveformContainer class="waveform" (click)="seek($event)">
    @for (bar of waveformBars(); track $index) {
      <div class="waveform-bar" [style.height.%]="bar.height" [class.played]="bar.played"></div>
    }
  </div>

  <div class="time-display">
    @if (audioSourceUpdating() || isLoading()) {
      <mat-icon class="mat-icon-spin">progress_activity</mat-icon>
    } @else {
      @if (!isPlaying() && currentTime() === 0) {
        <span class="time">{{ durationDisplay() }}</span>
      } @else {
        <span class="time">{{ timeDisplay() }}</span>
      }
    }
  </div>

  <button mat-icon-button #optionsButton (click)="onOptionsClick($event, optionsButton)" [disabled]="isLoading()" aria-label="More options">
    <mat-icon>more_horiz</mat-icon>
  </button>
</div>
